import { createFileRoute } from '@tanstack/react-router';

import { KitGallery } from '~/features/dev/kit-gallery';

/** Every component of the web kit, in its states. A developer page, open to anyone. */
export const Route = createFileRoute('/dev/kit')({ component: KitGallery });
